import { Route } from "react-router-dom";
import { CreateProject, UpdateProject } from "../Projects/Project";
import {
	CASProjectList,
	FinanceProjectList,
	ProjectList,
	UsersProjectsList,
} from "../Projects/Table/ProjectList";
import {
	UploadDocumentFile,
	UploadProposalFile,
} from "../UploadFile/UploadFile";

export const PROJECT_ROUTES = [
	<Route key="projects" path="/projects" element={<ProjectList />} />,
	<Route
		key={"projects-cas"}
		path="/projects/cas"
		element={<CASProjectList />}
	/>,
	<Route
		key="projects-finance"
		path="/projects/finance"
		element={<FinanceProjectList />}
	/>,
	<Route
		key="projects-create"
		path="/projects/create_project"
		element={<CreateProject />}
	/>,
	<Route
		key="projects-update"
		path="/projects/update_project/:id"
		element={<UpdateProject />}
	/>,
	<Route
		key="projects-upload"
		path="/projects/upload_file/:id"
		element={<UploadDocumentFile />}
	/>,
	<Route
		key="projects-upload-proposal"
		path="/projects/upload_proposal/:id"
		element={<UploadProposalFile />}
	/>,
	<Route
		key="projects-users"
		path="/projects/user_projects"
		element={<UsersProjectsList />}
	/>,
];
